import React from 'react'
import { GetFormat, useGet } from 'sharedKernel/api'
import { HotsiteChallengeProps } from 'domain/feature/hotsite/store/contracts'
import { saveHotsiteChallenges, store } from 'store'
import { EventsPageMain } from 'domain/feature/hotsite/EventsPage'
import { Loading } from 'components/loading'

export const EventsPage = (): JSX.Element => {
  const request: GetFormat = {
    url: '/v1/hotsite/challenge?page=1'
  }
  const { data, isFetching } = useGet<HotsiteChallengeProps[]>(request, 'hotsite-events')

  const renderResponse = (): JSX.Element => {
    if (isFetching) {
      return (
        <div style={{ height: '100vh' }}>
          <Loading />
        </div>
      )
    }
    if (data !== undefined) {
      data.rows = data?.rows.filter((challenge) => challenge.isActive)
      store.dispatch(saveHotsiteChallenges(data))
    }

    return <EventsPageMain />
  }

  return (
    <>
      {renderResponse()}
    </>
  )
}
